export const SERVICE_KEY = 'hitl-api';
export const EKS_SERVICE_KEY = 'hitl-eks-api';
export const HITL_API_SERVICE_KEY = SERVICE_KEY;
//# sourceMappingURL=constants.js.map